import React from 'react'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import moment from '../../lib/moment.js'
import get from 'lodash/get'
import { year_of_service_table_header, FONTS, COLORS } from '../../constants'
import arrow_down from '../../static/images/arrow-down.svg'
import arrow_up from '../../static/images/arrow-up.svg'

export default class YearOfServiceTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      sort_order: null,
      sort_column: 0,
    }
    this.handleClickSort = this.handleClickSort.bind(this)
  }
  handleClickSort(type) {
    if (type === this.state.sort_column) {
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      this.setState({
        sort_order: !this.state.sort_order,
        sort_column: type,
      })
    }
    if (type === 0) this.props.sortBy('emp_code', !this.state.sort_order)
    else if (type === 1) this.props.sortBy('name', !this.state.sort_order)
    else if (type === 2) this.props.sortBy('company_name', !this.state.sort_order)
    else if (type === 3) this.props.sortBy('lob_name', !this.state.sort_order)
    else if (type === 4) this.props.sortBy('department_name', !this.state.sort_order)
    else if (type === 5) this.props.sortBy('hiring_date', !this.state.sort_order)
    else if (type === 6) this.props.sortBy('year_of_service', !this.state.sort_order)
  }
  render() {
    const { sort_order, sort_column } = this.state
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                year_of_service_table_header.map((h) =>
                  (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }</HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable>
            {
              get(this.props, 'yos', []).map((d, key) =>
                (<tr
                  key={ shortid() }
                  style={ { hover: '#E5E5E5', background: (key === get(this.props, 'rowID') && get(this.props, 'isSpan')) ? '#E5E5E5' : '' } }
                >
                  <td>{ d.emp_code }</td>
                  <td>{ `${d.first_name} ${d.last_name}` }</td>
                  <td>{ d.company_name }</td>
                  <td>{ d.lob_name }</td>
                  <td>{ d.department_name }</td>
                  <td>{ moment(d.hiring_date).format('DD/MM/YYYY') }</td>
                  <td>{ d.year_of_service }</td>
                </tr>)
              )}
          </BodyTable>
        </NewTable>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead, tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 330px);
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`
const Icon = styled.img`
  height : 10px;
  margin-left: 5%;
`



// WEBPACK FOOTER //
// ./src/components/table-year-of-service/index.js